import { render, staticRenderFns } from "./VideoDirectorConfiguration.vue?vue&type=template&id=33124273&"
import script from "./VideoDirectorConfiguration.vue?vue&type=script&lang=js&"
export * from "./VideoDirectorConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./VideoDirectorConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports